<template>
  <el-table
    :data="sys"
    border
    :cell-style="rowStyle"
    :header-cell-style="{ background: '#409EFF', color: '#fff', textAlign: 'center'}"
  >
    <el-table-column
      prop="type"
      label="類別"
    >
    </el-table-column>
    <el-table-column
      prop="instrument"
      label="儀器或設備數量"
    >
    </el-table-column>
    <el-table-column
      prop="GREEN"
      label="正常"
    >
    </el-table-column>
    <el-table-column
      prop="err"
      label="異常(含未更新)">
      <template slot-scope="scope">
        <div v-if="scope.row.err !== 0">
          <el-popover
            placement="top"
            trigger="hover">
            <div v-for="(err, index) in scope.row.err_name" :key="index">
              <p class="multiline" @click="handleClick(err)">{{ err }}</p>
            </div>
            <span slot="reference">{{ scope.row.err }}</span>
          </el-popover>
        </div>
        <div v-else>
          <span>{{ scope.row.err }}</span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
const SYS_MAP = {
  iotNodeStatus: 'IoT Node/儀器狀態',
  cwaRainGauge: '氣象署雨量站',
  cctvStatus: 'CCTV 狀態',
};

export default {
  name: 'systemHealth',
  props: {
    projectData: {
      type: Object,
      default: () => ({}),
    },
    instrumentsList: {
      type: Object,
      default: () => ({}),
    },
    sysTypes: {
      type: Array,
      default: () => [
        'iotNodeStatus',
        'cwaRainGauge',
        'cctvStatus',
      ],
    },
  },
  data() {
    return {
      resData: null,
      type: ['STI', 'MC', 'ELP', 'SAA', 'TM', 'LC', 'RAIN', 'DS', 'ETI', 'CG'],
      sys: [],
      instrumentList: [],
      instrumentGroup: [],
    };
  },
  mounted() {
    this.initSys();
    this.resData = this.instrumentsList;
    this.getProject();
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
  },
  methods: {
    initSys() {
      this.sys = this.sysTypes.map(key => {
        let instrument = 0;
        let GREEN = 0;
        let err = 0;

        if (key === 'cctvStatus') {
          instrument = 1;
          GREEN = 1;
          err = 0;
        }

        return {
          key,
          type: SYS_MAP[key],
          instrument,
          GREEN,
          err,
          err_name: [],
        };
      });
    },
    findSys(key) {
      return this.sys.find(s => s.key === key);
    },
    handleClick(err) {
      console.log('Clicked on: ', err);
    },
    
    instrumentHealth() {
      const sysIotStatus = this.findSys('iotNodeStatus');
      const cwaRainStatus = this.findSys('cwaRainGauge');
      
      if(sysIotStatus) { sysIotStatus.instrument = 0; sysIotStatus.GREEN = 0; sysIotStatus.err = 0; sysIotStatus.err_name = []; }
      if(cwaRainStatus) { cwaRainStatus.instrument = 0; cwaRainStatus.GREEN = 0; cwaRainStatus.err = 0; cwaRainStatus.err_name = []; }

      Object.values(this.instrumentGroup).forEach(group => {
        const item = group[0];
        
        if (sysIotStatus && item.type === 'iot') {
          sysIotStatus.instrument++;
          if (group.group_status === 'down') {
            sysIotStatus.err++;
            sysIotStatus.err_name.push(item.name);
          } else {
            sysIotStatus.GREEN++;
          }
          return;
        }

        if (cwaRainStatus && item.type === 'RAIN') {
          cwaRainStatus.instrument++;
          if (group.group_status === 'down') {
            cwaRainStatus.err++;
            cwaRainStatus.err_name.push(item.name);
          } else {
            cwaRainStatus.GREEN++;
          }
        }
      });
    },
    rowStyle() {
      return 'text-align:center';
    },
    getProject() {
      this.getInstrumentStatus(this.projectData, this.type);
      this.getInstrumentGroup();
      this.instrumentHealth();
    },
    
    getInstrumentGroup() {
      const priorityOrder = ['down', 'WSL', 'AL', 'GREEN'];
      
      this.instrumentGroup = this.instrumentList.reduce((acc, item) => {
        if (item.class !== '') {
          const cleanClass = item.class ? item.class.trim() : 'UnknownClass';
          
          const uniqueKey = `${item.areaName}_${cleanClass}`;

          if (acc[uniqueKey]) {
            acc[uniqueKey].push(item);

            const itemPriority = priorityOrder.indexOf(item.status);
            const currentGroupStatusPriority = priorityOrder.indexOf(acc[uniqueKey].group_status);

            if (itemPriority < currentGroupStatusPriority) {
              acc[uniqueKey].group_status = item.status;
            }
          } else {
            acc[uniqueKey] = [item];
            acc[uniqueKey].group_status = item.status;
          }
        }
        return acc;
      }, {});
    },

    getInstrumentStatus(data, types) {
      if (!data || !data.area) return;

      this.instrumentList = []; 

      data.area.forEach(area => {
        const areaName = area.name || 'UnknownArea';

        area.station.forEach(stationNode => {
          const stationName = stationNode.name || 'UnknownStation';

          if (!stationNode.instrument) return;

          stationNode.instrument.forEach(item => {
            const name = item.latestVersion.name;
            const itemClass = item.latestVersion.class;
            
            if (name.includes('Batt')) return;

            const baseData = {
              name,
              status: item.status,
              class: itemClass,
              stationName,
              areaName,
            };

            if (name.includes('雨量')) {
              this.instrumentList.push({
                ...baseData,
                type: 'RAIN',
              });
              return; 
            }

            const isTargetType = types.some(t => name.includes(t));

            if (isTargetType) {
              this.instrumentList.push({
                ...baseData,
                type: 'iot',
              });
            }
          });
        });
      });
    },
  },
};
</script>